/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { fetchRemnantLifeAlertsData, fetchRemnanatCount } from "../../../api/alertsApi";
import { toast } from "react-toastify";


function useGetRemnantLifeAlertsData(filter,pageSize,currentPage,order_by,order_dir, refreshToggle, isTokenReady) {
    const [data, setData] = useState({
        alertsList: [],
        alertsCount: 0
    });

    let offset = (currentPage - 1) * pageSize;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (isTokenReady){
            setLoading(true);
            Promise.all([
                fetchRemnantLifeAlertsData(filter, pageSize, offset, order_by, order_dir),
                fetchRemnanatCount(filter)      
            ]).then(([alertsList, alertsCount]) => {
                setData({
                    alertsList,
                    alertsCount
                });
                setLoading(false);
            }).catch((error) => {
                console.error(error);
                toast.error(`Cannot fetch Remnant Alerts List`);
                setError(error);
            })
        }

    }, [currentPage, order_by, order_dir, filter, refreshToggle, isTokenReady]);
    console.log("loading", loading)
    return { data, loading, error };
}


export default useGetRemnantLifeAlertsData;